import React, { useEffect } from 'react';
import { Button, RadioButton, TextArea, Title } from '@gerdau/hefesto';
import { Chips } from '@gerdau/hefesto-mais-web';
import { useDispatch } from 'react-redux';
import { IDeliveryConditions } from '../../../../store/ducks/contracts-and-constructions/types';
import {
  EDischargeTypes,
  EVehicleTypes,
  IDayAndTimeToReceive
} from '../../../../store/ducks/fabrication-contracts/types';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import { EConstructionRegistrationRoutes } from '../constructionRegistration.routes';
import { isAllFieldsValidInDeliveryConditions } from '../constructionRegistrationFieldsValidations';
import DaysAndTime from './DaysAndTime';
import { Container } from './styles';

interface IDeliveryConditionsProps {
  goToConstructionRegistrationRoute(
    route: EConstructionRegistrationRoutes
  ): void;
  deliveryConditions: IDeliveryConditions;
  setDeliveryConditions(deliveryConditions: IDeliveryConditions): void;
}

const DeliveryConditions: React.FC<IDeliveryConditionsProps> = ({
  goToConstructionRegistrationRoute,
  deliveryConditions,
  setDeliveryConditions
}) => {
  const dispatch = useDispatch();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleUpdateStateField = (field: string, newValue: any) => {
    setDeliveryConditions({
      ...deliveryConditions,
      [field]: newValue
    });
  };

  useEffect(() => {
    dispatch(
      sendTagging({
        screenName: 'LG:ContratosEObras:CadastroDeObra:CondicoesDeEntrega',
        page: window.location.pathname,
        event: 'page_view'
      })
    );
  }, []);

  const options = Object.values(EVehicleTypes).map((vehicle) => ({
    id: vehicle.toString(),
    label: vehicle.toString()
  }));

  const nextStep = () => {
    dispatch(
      sendTagging({
        screenName: 'LG:ContratosEObras:CadastroDeObra:CondicoesDeEntrega',
        itemName: 'button:avancar_para_responsavel_pela_obra',
        event: 'click',
        itemDescription: `contratosEObras_cadastroDeObra_condicoesDeEntrega_avancarParaResponsavelPelaObra`
      })
    );

    goToConstructionRegistrationRoute(
      EConstructionRegistrationRoutes.RESPONSIBLE_OF_CONSTRUCTION
    );
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const previousStep = () => {
    dispatch(
      sendTagging({
        screenName: 'LG:ContratosEObras:CadastroDeObra:CondicoesDeEntrega',
        itemName: 'button:voltar',
        event: 'click',
        itemDescription: `contratosEObras_cadastroDeObra_condicoesDeEntrega_voltar`
      })
    );

    goToConstructionRegistrationRoute(
      EConstructionRegistrationRoutes.CONSTRUCTION_DATA
    );
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <Container>
        <Title level={2}>
          Em quais dias e horários a obra pode receber entregas?
        </Title>
        <DaysAndTime
          allowedDaysAndTimeToReceive={
            deliveryConditions.allowedDaysAndTimeToReceive
          }
          setAllowedDaysAndTimeToReceive={(
            allowedDaysAndTimeToReceive: IDayAndTimeToReceive[]
          ) =>
            handleUpdateStateField(
              'allowedDaysAndTimeToReceive',
              allowedDaysAndTimeToReceive
            )
          }
        ></DaysAndTime>
      </Container>

      <Container>
        <Title level={2}>Quais tipos de veículo a obra pode receber?</Title>
        <span className="subtitle">Selecione uma ou mais opções:</span>

        <Chips
          chips={options}
          handleSelect={(e) => {
            handleUpdateStateField('allowedVehicleTypes', e);
          }}
          type="filter"
        />
      </Container>

      <Container>
        <Title level={2}>Qual tipo de descarga a obra pode fazer?</Title>
        <span className="subtitle">Selecione uma opção:</span>

        <span className="radioContainer">
          {Object.values(EDischargeTypes).map((dischargeType, idx) => (
            <RadioButton
              key={idx}
              id={dischargeType}
              value={dischargeType}
              checked={
                deliveryConditions.allowedDischargeType === dischargeType
              }
              label={dischargeType}
              name={dischargeType}
              onChange={(e) =>
                handleUpdateStateField('allowedDischargeType', e.target.value)
              }
            />
          ))}
        </span>

        <Title level={3}>Observações sobre a descarga:</Title>

        <TextArea
          cols={200}
          resizable={false}
          value={deliveryConditions.dischargeObservation}
          placeholder="Digite as observações sobre o seu pedido"
          label=""
          name="observations"
          onChange={(e) =>
            handleUpdateStateField('dischargeObservation', e.target.value)
          }
        />
      </Container>
      <Container>
        <span className="btnContainer">
          <Button onClick={previousStep} name="prevStep">
            Voltar
          </Button>
          <Button
            disabled={!isAllFieldsValidInDeliveryConditions(deliveryConditions)}
            onClick={nextStep}
            name="nextStep"
          >
            Avançar para responsável pela obra
          </Button>
        </span>
      </Container>
    </>
  );
};

export default DeliveryConditions;
